const routes = [
    {
        name: 'ConfigGerais',
        path: 'configuracoes/gerais',
        component: () => import('../views/ConfigGeraisView'),
    }
]

export default routes

